import script from "./RoadMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoadMap.vue?vue&type=script&lang=ts&setup=true"

import "./RoadMap.vue?vue&type=style&index=0&id=c833a97a&lang=sass"

const __exports__ = script;

export default __exports__